import { definirAppDeclaree } from '@taki/app-runtime';
import appInfo from './taki.app.json';
import champs from './taki.fields.json';
import ecrans from './taki.screens.json';
import { DossierDeConsultation } from './canvas/DossierDeConsultation.js';
import { importDemoDataset } from './demo-dataset.js';

/**
 * LA VUE DE FICHE « Dossier de consultation » (`vue:consultations.dossier`) :
 * sa carte dans `vuesCustom` de `taki.screens.json` (niveau fiche, jeu des
 * consultations), son accord dans `canvas.views` de `taki.app.json` (regle
 * G23), son rendu dans `canvas/DossierDeConsultation.tsx`. La Fiche native
 * reste la, dans le selecteur.
 */
export const consultationsApp = definirAppDeclaree({
  fiche: appInfo,
  champs,
  ecrans,
  canvas: { 'vue:consultations.dossier': DossierDeConsultation },
  demo: {
    ecrit: [
      { family: 'careRecords', type: 'consultation' }, { family: 'careRecords', type: 'soin' },
      { family: 'inspections', type: 'examen' }, { family: 'inspections', type: 'complementaire' },
      { family: 'measurements', type: 'constante' }, { family: 'todos', type: 'dossier' },
      { family: 'templates', type: 'careRecords' },
    ],
    importer: ({ sdk, orgId, moi }) => importDemoDataset(sdk, orgId, moi),
  },
});
export default consultationsApp;
